import React, { ReactNode } from 'react'

import { Div } from 'elements/layout/Div'
import { TFixedDivProps } from 'elements/layout/FixedDiv'

type THeaderWrapperProps = {
  children: ReactNode
  id?: string
} & Pick<TFixedDivProps, 'bg'>

export const HeaderWrapper: TFC<THeaderWrapperProps> = ({ id, children, bg = 'transparent' }) => (
  <Div
    id={id || 'header-wrapper'}
    as="header"
    // in SSR, always appear
    bg={bg}
    noPrint
  >
    {children}
  </Div>
)
